/**
 * @file warning-popup.ts
 * @module app/modules/_common/components/pop-up/warning-popup
 * @description Utility for displaying a warning popup.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { showPopup } from './popup-service';
import type { PopupOptions } from './popup-service';

const showWarningPopup = (options: PopupOptions | string = {}) =>
  showPopup('warning', options);

export default showWarningPopup;